import React, {Component} from 'react'
import PropTypes from 'prop-types'
import getBasketDetail from "../actions/getBasketDetail"
import BasketDetail from "../../merger-v2/components/BasketDetail"
import classNames from 'classnames'


class BasketDetailPage extends Component {
    state = {
        loading: false,
        error: '',
        basket: null,
    }

    componentDidMount() {
        this._fetchBasket()
    }

    _fetchBasket = async () => {
        if (this.state.loading) return false

        this.setState({
            loading: true,
            error: ''
        })

        try {
            const basket = await getBasketDetail(this.props.id)

            this.setState({
                loading: false,
                error: '',
                basket,
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
            })
        }
    }

    _handleClose = () => {
        this._fetchBasket()
    }

    render() {
        const {loading, basket, error} = this.state

        return (
            <div className={classNames("BasketDetailPage", {loading})}>
                {
                    !!error &&
                    <div className="alert alert-danger">
                        <div className="Huge">
                            <strong>Lỗi: </strong>
                            <span>{error}</span>
                        </div>
                    </div>
                }
                {
                    !!basket &&
                    <BasketDetail result={basket} onClose={this._handleClose} disabledCheckExists onFetchBasket={this._fetchBasket}/>
                }
            </div>
        )
    }
}

BasketDetailPage.propTypes = {
    id: PropTypes.string.isRequired,
}

export default BasketDetailPage
